import {FactoryFn} from './factory-function';
import {SpecOption, Variation} from '@sportngin/se-commerce-sdk/models/clare';

interface Variant {
  id: string;
  name?: string;
  priceCents?: number;
  specs: VariantSpec[] | undefined;
}

interface VariantSpec {
  specId: string;
  optionId: string;
  value: string | undefined;
  name: string;
  displayOrder: number;
}

const specOptionToVariantSpec: FactoryFn<SpecOption, VariantSpec> = (
  source: SpecOption,
): VariantSpec => {
  return {
    optionId: String(source.id),
    specId: String(source.product_spec?.id ?? ''),
    name: source.product_spec?.name || '',
    value: source.name,
    displayOrder: source.product_spec?.display_order ?? 0,
  };
};

const clareVariationToVariant: FactoryFn<Variation, Variant> = (
  source: Variation,
): Variant => {
  return {
    id: String(source.id),
    name: source.name,
    priceCents: source.price_cents,
    specs: source.spec_options?.map(specOptionToVariantSpec),
  };
};

export {Variant, VariantSpec, clareVariationToVariant, specOptionToVariantSpec};
